export const PRODUCT_QUERY_KEY = 'product';
export const PRODUCTS_QUERY_KEY = 'products';
